// TQC2020_R01 그리드/API 응답용 (일자·품목·공정 탭) — ColumnDefinitions·백엔드 projection과 키 맞춤

import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface DateProductResultDto extends ProductResultDto {

    inspectDt?: string;    // 검사일자 (목록 API)
    inspectorEmpNm: string;  // 검사자 표시명 (백엔드 inspectorEmpNm projection)
    workerEmpNm: string;   // 작업자 표시명 (백엔드 workerEmpNm 또는 productEmpNm)
}

export interface ItemProductResultDto extends ProductResultDto {
    inspectDt?: string;    // 검사일자 (목록 API)
    inspectorEmpNm: string;  // 검사자 표시명
    workerEmpNm: string;   // 작업자 표시명
}

export interface WorkplaceProductResultDto extends ProductResultDto {
    inspectDt?: string;    // 검사일자 (목록 API)
    inspectorEmpNm: string;  // 검사자 표시명
    workerEmpNm: string;   // 작업자 표시명
}

// 통합 DTO (서버 응답 제네릭을 위한 공통 타입)
export type TQC2020_R01Dto = DateProductResultDto | ItemProductResultDto | WorkplaceProductResultDto;

// 기본값
export const defaultDateProductResult: DateProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inspectDt: '',
    inspectorEmpNm: '',
    workerEmpNm: '',
	
	inserted: false,
	isModified: false,
};

export const defaultItemProductResult: ItemProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inspectDt: '',
    inspectorEmpNm: '',
    workerEmpNm: '',
	
	inserted: false,
	isModified: false,
};

export const defaultWorkplaceProductResult: WorkplaceProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inspectDt: '',
    inspectorEmpNm: '',
    workerEmpNm: '',
	
	inserted: false,
	isModified: false,
};

export const defaultTQC2020_R01Dto: TQC2020_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inspectDt: '',
    inspectorEmpNm: '',
    workerEmpNm: '',
	
	inserted: false,
	isModified: false,
};
